'use client';

import { useMemo } from 'react';
import { Country } from '@/helpers/conf';
import { useCurrentCountry } from '@/hooks/useCurrentCountry';
import { useInfoProject } from '@/modules/common';
import { MenuClientHideConditions, type ServerLink } from '../helpers';
import AboutUsButton from './AboutUsButton';
import { FooterMenuLinkClientWrapper } from './FooterMenuLinkClientWrapper';

import { ScFooterItem, ScMenuBottom } from './styled';

type FooterMenuProps = {
  links: ServerLink[];
};

export const FooterMenu = ({ links }: FooterMenuProps) => {
  const isAustralia = useCurrentCountry(Country.Australia);
  const { data: project, isLoading: projectPending } = useInfoProject();

  const isReferralProgramAvailable = useMemo(
    () => !projectPending && project?.availableReferralSystem,
    [projectPending, project?.availableReferralSystem]
  );

  const hideConditionResults = {
    [MenuClientHideConditions.isReferralPage]: !isReferralProgramAvailable,
    [MenuClientHideConditions.IsAustralia]: isAustralia,
  };

  return (
    <ScFooterItem>
      <ScMenuBottom>
        {links.map(({ id, url, hideConditions, serverComponent }) => (
          <FooterMenuLinkClientWrapper
            hideConditionResults={hideConditionResults}
            hideConditions={hideConditions}
            key={id}
            url={url}
          >
            {serverComponent}
          </FooterMenuLinkClientWrapper>
        ))}

        <li>
          <AboutUsButton />
        </li>
      </ScMenuBottom>
    </ScFooterItem>
  );
};
